import { EappEnum } from './eAppEnum';

const ACTIVE_MILITARY = 'ActiveMilitary';
const US_MILITARY = 'USMilitary';
const NATIONAL_GUARD = 'NationalGuard';
const USPHS = 'USPHS';
const OTHER_FEDERAL = 'OtherFederal';
const STATE_GOVERNMENT = 'StateGovernment';
const FEDERAL_CONTRACTOR = 'FederalContractor';
const NON_GOVERNMENT = 'NonGovernment';
const OTHER = 'Other';
export const SELF_EMPLOYMENT = 'SelfEmployment';
export const UNEMPLOYMENT = 'Unemployment';

export const employmentActivityOptions:string[] = [
  ACTIVE_MILITARY,
  NATIONAL_GUARD,
  USPHS,
  OTHER_FEDERAL,
  STATE_GOVERNMENT,
  FEDERAL_CONTRACTOR,
  NON_GOVERNMENT,
  OTHER,
  SELF_EMPLOYMENT,
  UNEMPLOYMENT,
];

export const employmentActivityPvqOptions:string[] = [
  US_MILITARY,
  OTHER_FEDERAL,
  STATE_GOVERNMENT,
  FEDERAL_CONTRACTOR,
  NON_GOVERNMENT,
  OTHER,
  SELF_EMPLOYMENT,
  UNEMPLOYMENT,
];

export const militaryEmploymentOptions = [ACTIVE_MILITARY, NATIONAL_GUARD, USPHS];

export const otherEmploymentOptions = [
  OTHER_FEDERAL,
  STATE_GOVERNMENT,
  FEDERAL_CONTRACTOR,
  NON_GOVERNMENT,
  OTHER,
];

export const employmentModel = {
  status: {
    Status: {}
  },
  reference: {
    ReferenceName: {},
    ReferencePhone: {},
    ReferenceAddress: {},
    ReferenceAlternateAddress: {},
    ReferenceAlternateAddressPhysicalComments: {},
    ReferenceAlternateAddressAnswerComments: {},
    ReferenceAlternateAddressComments: {},
  },
  employer: {
    Employer: {}
  },
  selfEmployment: {
    SelfEmploymentComments: {},
    ReferenceComments: {},
  },
  unemployment: {
    UnemploymentComments: {}
  },
  additionalActivity: {
    NonMilitaryEmploymentComments: {},
    Additional: {},
  },
  assignedDuty: {
    DutyStation: {},
    MilitaryEmploymentComments: {},
  },
  physicalAddress: {
    PhysicalAddress: {},
    PhysicalAddressAnswerComments: {},
    PhysicalAddressComments: {},
    PhysicalAlternateAddress: {},
    AddressPhysicalComments: {},
    AddressComments: {},
    AddressAnswerComments: {},
  },
  supervisor: {
    Supervisor: {},
    SupervisorAlternateAddress: {},
    SupervisorAlternateAddressPhysicalComments: {},
    SupervisorAlternateAddressComments: {},
    SupervisorAlternateAddressAnswerComments: {},
  },
  employed: {
    Title: {},
    Address: {},
    Telephone: {},
    AlternateAddress: {},
    ReasonLeft: {},
    ReasonLeftComments: {},
    ReasonLeftAnswerComments: {},
    WasFired: {},
    FiredDetails: {},
    WasLeaveBeforeFired: {},
    LeaveBeforeFiredDetails: {},
    WasLeaveAfterNoticeMisconduct: {},
    LeaveAfterNoticeMisconductDetails: {},
    WasleaveAfterNoticePerformance: {},
    LeaveAfterNoticePerformanceDetails: {},
    WasLeavePendingOutcome: {},
    LeavePendingOutcome: {},
    Reprimand: {},
    ReprimandAnswerComments: {},
    ReprimandComments: {},
  }
};

// PVQ Dropdown values
export const employmentActivityTypes = new EappEnum([
  {
    i18nField: 'usmilitary', value: 'USMilitary', key: 'uSMilitary', text: 'U.S. Military or Uniformed Service (U.S. Army, Navy, Marine, Coast Guard, Air Force, Space Force, USPHS, or NOAA)'
  },
  {
    i18nField: 'otherfederal', value: 'OtherFederal', key: 'otherFederal', text: 'Other Federal Employment'
  },
  {
    i18nField: 'federalcontractor', value: 'FederalContractor', key: 'federalContractor', text: 'Federal Contractor'
  },
  {
    i18nField: 'stategovernment', value: 'StateGovernment', key: 'stateGovernment', text: 'State Government Employment'
  },
  {
    i18nField: 'nongovernment', value: 'NonGovernment', key: 'nonGovernment', text: 'Non-government Employment (do not include self-employment)'
  },
  {
    i18nField: 'selfemployment', value: 'SelfEmployment', key: 'selfEmployment', text: 'Self-employed'
  },
  {
    i18nField: 'unemployment', value: 'Unemployment', key: 'unemployment', text: 'Unemployed'
  },
]);

// PVQ Dropdown values
export const employmentMilitaryBranchValues = new EappEnum([
  {
    i18nField: 'airnationalguard', value: 'Air National Guard', key: 'airNationalGuard', text: 'Air National Guard'
  },
  {
    i18nField: 'otherfederal', value: 'Army National Guard', key: 'otherFederal', text: 'Army National Guard'
  },
  {
    i18nField: 'noaacoc', value: 'National Oceanic and Atmospheric Administration Commissioned Officer Corps', key: 'noaacoc', text: 'National Oceanic and Atmospheric Administration Commissioned Officer Corps'
  },
  {
    i18nField: 'usairforce', value: 'U.S. Air Force', key: 'usAirForce', text: 'U.S. Air Force'
  },
  {
    i18nField: 'usarmy', value: 'U.S. Army', key: 'usArmy', text: 'U.S. Army'
  },
  {
    i18nField: 'uscoastguard', value: 'U.S. Coast Guard', key: 'usCoastGuard', text: 'U.S. Coast Guard'
  },
  {
    i18nField: 'usmarinecorps', value: 'U.S. Marine Corps', key: 'usMarineCorps', text: 'U.S. Marine Corps'
  },
  {
    i18nField: 'usnavy', value: 'U.S. Navy', key: 'usNavy', text: 'U.S. Navy'
  },
  {
    i18nField: 'uspublichealthservicecommissionedcorps', value: 'U.S. Public Health Service Commissioned Corps', key: 'usPublicHealthServiceCommissionedCorps', text: 'U.S. Public Health Service Commissioned Corps'
  },
  {
    i18nField: 'usspaceforce', value: 'U.S. Space Force', key: 'usSpaceForce', text: 'U.S. Space Force'
  },
]);

export const assignedDutyStatusTypes = new EappEnum([
  {
    i18nField: 'activeduty', value: 'Active Duty', key: 'ActiveDuty', text: 'Active Duty'
  },
  {
    i18nField: 'activereserve', value: 'Active Reserve/Guard', key: 'ActiveReserveGuard', text: 'Active Reserve/Guard'
  },
  {
    i18nField: 'traditionalreservist', value: 'Traditional Reservist/Guardsman', key: 'TraditionalReservistGuardsman', text: 'Traditional Reservist/Guardsman'
  },
  {
    i18nField: 'inactivereserve', value: 'Inactive Reserves/Individual Ready Reserves', key: 'InactiveReservesIndividualReadyReserves', text: 'Inactive Reserves/Individual Ready Reserves'
  },
  {
    i18nField: 'retiredreserve', value: 'Retired Reserve', key: 'RetiredReserve', text: 'Retired Reserve'
  },
  {
    i18nField: 'other', value: 'Other', key: 'Other', text: 'Other'
  },
]);

// PVQ Dropdown values
export const disciplineTypes = new EappEnum([
  { value: 'Written Warning', key: 'Written Warning', text: 'Written Warning' },
  { value: 'Official Counseling', key: 'Official Counseling', text: 'Official Counseling' },
  { value: 'Official Reprimand', key: 'Official Reprimand', text: 'Official Reprimand' },
  { value: 'Suspended', key: 'Suspended', text: 'Suspended' },
  { value: 'Demoted - Reduction in grade', key: 'Demoted - Reduction in grade', text: 'Demoted - Reduction in grade' },
  { value: 'Demoted - Reduction in pay', key: 'Demoted - Reduction in pay', text: 'Demoted - Reduction in pay' },
  { value: 'Removed from position, but not from employment', key: 'Removed from position, but not from employment', text: 'Removed from position, but not from employment' },
  { value: 'Other', key: 'Other', text: 'Other' },
]);

/**
 * Usedfor processing of employment dismissal items
 */
export const employmentDimissalTypes = {
  fired: 'fired',
  leaveBeforeFired: 'leaveBeforeFired',
  leaveAfterNoticeMisconduct: 'leaveAfterNoticeMisconduct',
  leaveAfterNoticePerformance: 'leaveAfterNoticePerformance',
  leavePendingOutcome: 'leavePendingOutcome'
};
